export const prefectures = [
  'hokkaido',
  'aomori', 'iwate', 'miyagi', 'akita', 'yamagata', 'fukushima',
  'tokyo', 'ibaraki', 'tochigi', 'gunma', 'saitama', 'chiba', 'kanagawa',
  'niigata', 'toyama', 'ishikawa', 'fukui', 'yamanashi', 'nagano', 'gifu', 'shizuoka', 'aichi',
  'kyoto', 'osaka', 'mie', 'shiga', 'hyogo', 'nara', 'wakayama',
  'tottori', 'shimane', 'okayama', 'hiroshima', 'yamaguchi',
  'tokushima', 'kagawa', 'ehime', 'kochi',
  'fukuoka', 'saga', 'nagasaki', 'oita', 'kumamoto', 'miyazaki', 'kagoshima', 'okinawa'
]

export const businessPropertyValues = {
  reportStatus: ['交渉中', '価格変更', '販売済', '売り止め', '公開前'],
  propertyTypes: {
    residential: ['新築一戸建て（億建）', '中古一戸億建て', '土地', 'ホテル・旅館', 'ゴルフ場', '新築マンション', '中古億ション', '中古マンション'],
    investment: ['一棟売りレジデンシャル', '一棟売りアパート', '一棟事業用ビル', '高級老人ホーム']
  }
}

export const rentalResidentialPropertyValues = {
  propertyTypes: ['新築マンション', '新築アパート', '中古マンション', '中古アパート', '貸一戸建'],
  reportStatus: ['空室', '審査中', '入居中', '原状回復工事中']
}

export const rentalCommercialPropertyValues = {
  propertyTypes: ['店舗', '事務所', '倉庫', '工場', '賃地'],
  reportStatus: ['空室', '審査中', '入居中', '原状回復工事中']
}

export const blogCategories = ['Latest', 'Life', 'City and Investment', 'Introduction to Real Estate Terms', 'Town navi']

export const propertyUses = ['Residential use', 'For investment']

export const propertyPrices = ['１億円', '１〜３億円', '３〜５億円', '５〜７億円', '７〜９億円', '10億円以上']

export const memberAges = ['20', '30', '40', '50', '60', '70', '80']

export const languages = ['Japanese', 'English', 'Simplified Chinese', 'Traditional Chinese']

export const administratorValues = {
  areaType: [
    { value: null, text: '選択してください', disabled: true },
    { value: 'Yokohama', text: '横浜' },
    { value: 'Sapporo', text: '札幌' },
    { value: 'HeadQuarters', text: '本部' }
  ],
  authorityType: [
    { value: null, text: '選択してください', disabled: true },
    { value: 'posting_permission', text: '投稿権限' },
    { value: 'editorial_rights', text: '編集権限' },
    { value: 'super_authority', text: 'スーパー権限' }
  ]
}
